export default {
  dom: {
    'afisha.24.24guru.by': '24.24guru.by',
    'cabinet.24.24guru.by': '24.24guru.by',
    'afisha.24guru.by': '24guru.by',
    'cabinet.24guru.by': '24guru.by',
    'dev.guru.ge': 'https://webgate.guru.ge',
    'afisha.headliner.show': 'headliner.show',
    'cabinet.headliner.show': 'headliner.show',
    'cabinet.24afisha.by': '24afisha.by',
  },

  server: {
    // prod
    '24guru.by': 'https://api.24afisha.by',
    'guru.ge': 'https://webgate.guru.ge',
    '24afisha.by': 'https://api.24afisha.by',
    'mtb.24afisha.by': 'https://api.24afisha.by',
    '24skidki.by': 'https://webgate.24guru.by',
    'headliner.show': 'https://webgate.headliner.show',
    'https://24guru.by/': 'https://webgate.24guru.by',
    'https://24afisha.by/': 'https://api.24afisha.by',
    'https://24skidki.by/': 'https://webgate.24guru.by',
    'https://headliner.show/': 'https://webgate.headliner.show',
    'dev.guru.ge': 'https://webgate.guru.ge',

    //  test
    '24.24guru.by': 'https://webgate.24guru.by',
    'afisha.24.24guru.by': 'https://webgate.24guru.by',
    'http://24.24guru.by/': 'https://webgate.24guru.by',
    'http://afisha.24.24guru.by/': 'https://webgate.24guru.by',
    '24afisha.arcom.of.by': 'https://webgate.arcom.of.by',
  },

  saleframe: {
    // prod
    '24guru.by': 'saleframe.24guru.by',
    '24afisha.by': 'saleframe.24afisha.by',
    'mtb.24afisha.by': 'saleframe.24afisha.by',
    'headliner.show': 'saleframe.headliner.show',

    // dev
    'afisha.24.24guru.by': 'saleframe.24guru.by',
    '24.24guru.by': 'saleframe.24guru.by',
  },

  cabinet: {
    '24guru.by': 'https://cabinet.24guru.by',
    '24afisha.by': 'https://cabinet.24guru.by',
    '24skidki.by': 'https://cabinet.24guru.by',
    '24.24guru.by': 'http://cabinet.24.24guru.by',
    'afisha.24.24guru.by': 'http://cabinet.24.24guru.by',
    'headliner.show': 'https://cabinet.headliner.show',
  },

  wizard: {
    '24guru.by': '//cabinet.24guru.by/wizard',
    '24afisha.by': '//cabinet.24guru.by/wizard',
    '24skidki.by': '//cabinet.24guru.by/wizard',
    'afisha.24guru.by': '//cabinet.24guru.by/wizard',
    'cabinet.24guru.by': '//cabinet.24guru.by/wizard',
    'afisha.24.24guru.by': '//cabinet.24.24guru.by/wizard',
    'cabinet.24.24guru.by': '//cabinet.24.24guru.by/wizard',
    isLocal: h => (h.match(/localhost:(300\d|808\d)/gi)
      ? 'localhost:4000' : '//cabinet.24.24guru.by/wizard'),
  },

  getBase(hostName) {
    return this.server[hostName] || this.server['24afisha.arcom.of.by'];
  },
  getCabinet(hostName) {
    return this.cabinet[hostName] || this.cabinet['afisha.24.24guru.by'];
  },
  getDomain(hostName) {
    return this.dom[hostName] || this.dom['afisha.24.24guru.by'];
  },
  getSubDomain(hostName) {
    return `.${this.getDomain(hostName)}`;
  },
  getWizard(hostname) {
    return this.wizard[hostname] || this.wizard.isLocal(hostname);
  },
};
